export const ButtonBasic = ({
  align = "none",
  fullWidth = true,
  label = "",
  onClick = () => true,
  icon = null,
  classes = "",
  color = "text-blue-600",
}) => {
  const alignClasses = () => {
    if (align === "left") return "justify-start";
    if (align === "right") return "justify-end";
    return;
  };
  return (
    <button
      className={`${fullWidth ? "w-full sm:px-10" : "w-auto"}
    flex items-center h-13 xl:h-16 rounded-4xl ${color} ${classes} ${alignClasses()}
    `}
      label={label}
      onClick={onClick}
    >
      <span className="text-base flex justify-start space-x-2">
        <div className="w-6">{icon}</div>
        <div className="line-clamp-1 text-left">
          {label}
        </div>
      </span>
    </button>
  );
};
